import { useDispatch, useSelector } from 'react-redux'

import CardGrey from '../../../common/CardGrey'
import InputBox from '../../../common/interactive/InputBox'
import { caseActions } from '../../../../store/case'
import { caseQuickUpdate } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import Button from '../../../common/Button'
import InputBoxCurrency from '../../../common/interactive/InputBoxCurrency'

import classes from '../Shared/Item.module.css'
import moduleClasses from './MajorMedPayments.module.css'

const MajorMedPaymentsControls = ({itemData, apiCase}) => {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const updateHandler = async (data) => {
       
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }

        setTimeout(() => {
            dispatch(caseActions.modifyActiveCase({
                folder: 'major_meds',
                item: {
                    itemId: itemData.id,
                    field: data.identifier.field,
                    value: data.data.value,
                },
            }))
        }, 0)

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        }        
        
    }

    return <div className={moduleClasses.major_med_payments_controls}>
        <div className={classes.row}>
            <div className={classes.row_item_full}>
                <CardGrey>
                    <div className={`${classes.flex_container} ${classes.space_betwen}`}>
                        <div className={classes.flex_container}>
                            <InputBoxCurrency label={'Available HRA ($)'} name={'available_hra'} action={updateHandler} identifier={{type: apiCase, field: 'available_hra', type_id: itemData.id}} currentValue={itemData.available_hra} fullBox={true}/>
                            <InputBoxCurrency label={'Available HSA ($)'} name={'available_hsa'} action={updateHandler} identifier={{type: apiCase, field: 'available_hsa', type_id: itemData.id}} currentValue={itemData.available_hsa} fullBox={true}/>
                        </div>
                        <div className={classes.flex_container}>  
                            <InputBox label={'PreAuth Phone Number'} type={'text'} name={'pre_auth_phone'} format={'phone'} action={updateHandler} identifier={{type: apiCase, field: 'pre_auth_phone', type_id: itemData.id}} currentValue={itemData.pre_auth_phone}/>
                            <InputBox label={'Ext'} type={'text'} name={'pre_auth_phone_ext'} action={updateHandler} identifier={{type: apiCase, field: 'pre_auth_phone_ext', type_id: itemData.id}} currentValue={itemData.pre_auth_phone_ext} maxWidth={80}/>
                            {itemData.pre_auth_phone && <a href={`tel:${itemData.pre_auth_phone}${itemData.pre_auth_phone_ext ? ";ext="+itemData.pre_auth_phone_ext : ''}`}>
                                <Button title={`tel:${itemData.pre_auth_phone}${itemData.pre_auth_phone_ext ? ";ext="+itemData.pre_auth_phone_ext : ''}`}>
                                    <i className='ti ti-phone'></i>
                                </Button>
                            </a>}
                        </div>
                        
                    </div>
                </CardGrey>
            </div>                        
        </div>         
    </div>
}

export default MajorMedPaymentsControls